<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
  	<span class="logo-mini">
  		<a href="/"><img src="/static/img/logo.svg" alt="Logo" class="img-responsive center-block logo"></a>
  	</span>
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li class="dropdown user user-menu">
            <a id="expiring-tariffs" class="dropdown-toggle" data-toggle="dropdown" href="javascript:;" style="visibility:hidden;">
              <i class="fa fa-bell"></i>
            </a>
            <ul class="dropdown-menu">
              <hr class="hr-text" data-content="Expiring Tariffs"/>
              <h5 class="text-center">Check for tariff(s) expiring <span class="badge">{{ days }}</span> day(s)</h5>
              <div class="text-center" style="margin:5px;">
                <div class="btn btn-default sq" @click="incr"><i class="fa fa-plus"></i></div>
                <div class="btn btn-default sq" @click="decr"><i class="fa fa-minus"></i></div>
              </div>
              <h5 class="text-center">&hellip;from&hellip;</h5>
              <div class="form-group pad-10" @click="stop">
                <date-picker :date="effectiveTo" :option="dateOption"></date-picker>
              </div>
              <h5 class="text-center" v-if="hasCheckedForTariffs && !checkingForTariffs">
                {{ getTariffCount }} expiring/expired tariff(s)
              </h5>
              <h5 class="text-center" v-if="hasCheckedForTariffs && checkingForTariffs">
                <pulse-loader size="5px"></pulse-loader>
              </h5>
              <div class="tariff-expiry-outer">
                <div>
                  <div class="btn btn-primary sq" style="width:49.9%" @click="getTariffs">
                    Check now
                  </div>
                  <parse-to-json
                    style="width:49%"
                    v-on:parse-start="parsing"
                    v-on:parse-complete="parsed"
                    :disabled="tariffs.length === 0"
                  ></parse-to-json>
                </div>
                <parse-from-json
                  :styles="{ csv: { width: '49.9%' }, xlsx: { width: '49%' } }"
                  :disabled="orderedTariffs.length === 0"
                  :json="this.orderedTariffs"
                  fileName="expiring-tariffs"
                ></parse-from-json>
              </div>
            </ul>
          </li>
          <li class="dropdown user user-menu">
            <a data-placement="bottom" data-toggle="tooltip" title="Logout" href="javascript:;" class="dropdown-toggle" @click="logout">
              <i class="fa fa-power-off"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper height-constraints">
      <right-side-bar></right-side-bar>
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1 v-if="!$route.meta.hide">
          {{ $route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>
        </h1>
        <ol class="breadcrumb">
          <li v-if="quoteExternalLink">
            <button class="btn btn-danger btn-external-link" @click="openExternalLink(quoteExternalLink.detail)">
              {{ quoteExternalLink.name }}
            </button>
          </li>
          <li @click="home" class="no-content-before">
            <a href="javascript:;">
              <i class="fa fa-home"></i>{{ getConst(locale, 'MENU_HOME') }}</a>
          </li>
          <li class="active">{{$route.name.toUpperCase()}}</li>
        </ol>
      </section>
      <div :class="[ $route.meta.hide ? 'mt45' : '' ]">
        <router-view></router-view>
      </div>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a target="_blank" href="https://www.moveassist.com">MAI</a>.</strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import RightSideBar from './RightSidebar'
import basei18n from '../mixins/base-i18n'
import ParseToJson from '../modules/helpers/ParseToJson'
import ParseFromJson from '../modules/helpers/ParseFromJson'
import API from '../api/endpoints'
import event from '../event'
import { fromTimestamp } from '../modules/helpers/DateHelpers'
import PulseLoader from '../modules/helpers/PulseLoader'
import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import dateOption from '../../static/js/date-picker-config.json'

export default {
  name: 'Dash',
  mixins: [basei18n],
  components: {
    RightSideBar,
    Sidebar,
    'right-side-bar': RightSideBar,
    ParseToJson,
    ParseFromJson,
    PulseLoader,
    DatePicker
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      hasCheckedForTariffs: false,
      tariffs: [],
      checkingForTariffs: false,
      days: 3,
      effectiveTo: {
        time: window.getYMDDate()
      },
      dateOption: dateOption
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    orderedTariffs () {
      let arr = [ ...this.tariffs ]
      return arr.sort((a, b) => {
        return new Date(a.effectiveTo) - new Date(b.effectiveTo)
      })
    },
    demo () {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard()
      }
    },
    locale () {
      return this.$store.getters['geolocation/country']
    },
    getTariffCount () {
      return this.hasCheckedForTariffs ? this.tariffs.length : 'an unkown amount of'
    },
    quoteExternalLink () {
      if (this.$route.name.toUpperCase() === 'ADD A NEW QUOTE') {
        return this.$store.getters['library/quoteExternalLink']
      }
    }
  },
  methods: {
    stop (e) {
      e.stopPropagation()
    },
    incr (e) {
      e.stopPropagation()
      if (this.days < 7) {
        this.days = this.days + 1
      } else if (this.days === 7) {
        this.days = 14
      } else if (this.days === 14) {
        this.days = 30
      } else if (this.days === 30) {
        this.days = 45
      } else if (this.days === 45) {
        this.days = 60
      }
    },
    decr (e) {
      e.stopPropagation()
      if (this.days === 60) {
        this.days = 45
      } else if (this.days === 45) {
        this.days = 30
      } else if (this.days === 30) {
        this.days = 14
      } else if (this.days === 14) {
        this.days = 7
      } else if (this.days > 3) {
        this.days = this.days - 1
      }
    },
    chunk (arr, iteration, chunk) {
      let start = iteration * chunk
      let end = start + chunk
      return arr.slice(start, end)
    },
    chunks (arr, chunkSize) {
      let totalChunks = (arr.length / chunkSize)
      let chunks = []
      for (let i = 0; i < totalChunks; i++) {
        chunks.push(this.chunk(arr, i, chunkSize))
      }
      return chunks
    },
    parsing () {},
    parsed ({ fileName, data }) {
      event.$emit('loading-on', { title: 'Uploading' })
      let promises = []
      let chunks = this.chunks(data, 50)
      chunks.forEach(chunk => {
        promises.push(this.$http.post(API.BATCH_CREATE_ADMIN_ENTITY('lookup'), chunk))
      })
      Promise.all(promises)
        .then(() => {
          event.$emit('toast', { type: 'success', message: 'All rows successfully uploaded' })
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'warning', message: 'An error occured uploading some rows; please check your document for create layout' })
        }).then(() => event.$emit('loading-off', {}))
    },
    getTariffs (e) {
      this.hasCheckedForTariffs = true
      this.checkingForTariffs = true
      e.stopPropagation()
      this.tariffs = []
      this.$http.get(API.GET_EXPIRING_TARIFFS(this.effectiveTo.time, this.days), { headers: { 'X-Lazy-Fetch': '0' } })
      .then(({data}) => {
        event.$emit('toast', { type: 'success', message: `${data.length} tariff(s) returned` })
        this.tariffs.push(...data.map(obj => {
          let o = {}
          o.id = obj.id
          o.effectiveTo = fromTimestamp(obj.effectiveTo)
          o.effectiveFrom = fromTimestamp(obj.effectiveFrom)
          o.name = obj.name
          o.contractName = obj.contractName
          o.ownerName = obj.owner !== null && obj.owner.hasOwnProperty('name') ? obj.owner.name : null
          o.ownerLocation = obj.owner !== null && obj.owner.hasOwnProperty('address') && obj.owner.address !== null ? obj.owner.address.subdivision : null
          return o
        }))
      }).catch(err => {
        event.$emit('toast', { type: 'error', message: `An error occurred fetching expiring tariffs` })
        console.log(err)
      }).then(() => {
        this.checkingForTariffs = false
      })
    },
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout () {
      this.$store.dispatch('authentication/invalidate')
        .then((res) => {
          this.$router.push({ path: '/login' })
        })
    },
    home () {
      this.$router.push({ path: '/' })
    },
    openExternalLink (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>

  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }

@media (max-width: 767px) {
  .main-header .logo {
    display: none;
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
}
.logo-lg img {
  padding: .4em !important;
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
.fa {
  margin-right: 0px !important;
}
.mt45 {
  margin-top: 45px;
}
.tariff-expiry-outer {
  background: #eee;
  padding: 5px;
}
.pad-10 {
  padding: 10px;
}
.no-content-before:before {
  content: none !important;
}
.btn-external-link {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?f7b5cd64